import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { CloudProvider } from '../../../../core/models/cloudProvider';
import { DeploymentJsonBody, DeploymentParameter, PartitionProp } from '../../../../core/models/deployment';
import { HpcConfig } from '../../../../core/models/node-config';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { DeploymentService } from '../../../../core/services/deployment.service';
import { NodeConfigService } from '../../../../core/services/node-config.service';

@Component({
  selector: 'app-new-update-partition',
  templateUrl: './new-update-partition.component.html',
  styleUrls: ['./new-update-partition.component.scss']
})
export class NewUpdatePartitionComponent implements OnInit {

  constructor(
    private deploymentService: DeploymentService,
    public dialogRef: MatDialogRef<NewUpdatePartitionComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
        depName: string,
        title: string,
        partitionProp: PartitionProp,
        cloud: string,
        provider: CloudProvider,
        action: string
    },
    private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar,
    public nodeConfigService: NodeConfigService,
    private authenticationService: AuthenticationService
  ) { }

  dialogTitle: string = "Create Node Group";
  partitionForm: UntypedFormGroup;
  isUpdate: boolean = false;
  nodeConfigNames: string[] = [];
  isFormSubmitted: boolean = false;
  bootDiskTypes: string[] = ["HDD", "SSD"]
  nicTypes: string[] = ["GVNIC"]
  networkTiers: string[] = ["PREMIUM"]
  dynamicNodes: number = 0;
  staticNodes: number = 0;
  hpcNodeConfigs: HpcConfig[] = [];
  currentUserRole =
    this.authenticationService.getRole() == ''
      ? null
      : this.authenticationService.getRole();
  showSkipDeployment: boolean = true;
  fieldTextType: boolean = true;
  cloudName: string = this.data.provider.providerName;
  cloudValue: number = +this.data.provider.providerValue;
  image: string = this.data.provider.providerIconFileName;

  @ViewChild('customHtmlBody') customHtmlBody: ElementRef;
  @ViewChild('skipDeployment') skipDeployment: ElementRef;
  htmlBody: string = '';

  async ngOnInit() {
    this.spinner.show('addDeployment');
    this.dialogTitle = this.data.title;
    if (!this.currentUserRole) {
      this.snackbar.open('You do not permission to add new deployment.', 'Ok');
    }
    this.htmlBody = await lastValueFrom(
      this.deploymentService.getCloudJsonValues(this.cloudValue, this.cloudName, this.data.depName, this.data?.partitionProp?.partitionName || '')
    );
    this.spinner.hide('addDeployment');
  }

  onClose() {
    this.dialogRef.close(false)
  }

  getNodeConfigs() {
    this.spinner.show('partition');
    this.nodeConfigService.getHpcConfigDetails(this.data.depName).subscribe({
      next: (data) => {
        if (data) {
          this.hpcNodeConfigs = JSON.parse(JSON.stringify(data))
          if (this.hpcNodeConfigs) {
            this.nodeConfigNames = this.hpcNodeConfigs?.map(nd => nd?.instanceCode);
            if (this.nodeConfigNames) {
              this.partitionForm.controls["machineType"].setValue(this.nodeConfigNames[0]);
              this.spinner.hide('partition');
            }
          }
        }
      },
      error: (err) => {
        this.spinner.hide('partition');
      }
    })
  }

  onCancel() {
    this.snackbar.dismiss();
    this.dialogRef.close();
  }

  onSubmit() {
    if (!this.currentUserRole) return;
    let elements = this.customHtmlBody.nativeElement.getElementsByTagName('tr');

    let depParams: DeploymentParameter[] = [];
    for (let i = 0; i < elements.length; i++) {
      let ele = elements[i].lastChild.firstChild;
      var depkey = ele.id;
      var depval = ele.value;
      let regexp = new RegExp(ele.getAttribute('pattern'));

      if (ele.hasAttribute('required')) {
        if (!depval) {
          this.snackbar.open(
            ele.parentElement.previousElementSibling.innerText.slice(0, -1) +
            ' Required!',
            'Ok'
          );
          return false;
        }
      }

      if (regexp && regexp.source != 'null') {
        if (!regexp.test(depval)) {
          this.snackbar.open(
            ele.parentElement.previousElementSibling.innerText.slice(0, -1) +
            ' is Invalid!',
            'Ok'
          );
          return false;
        }
      }

      depParams.push({ depKey: depkey, depValue: depval });
    }
    var depJsonBody = new DeploymentJsonBody(depParams);
    let skipCloudDep = (<any>this.skipDeployment)?.checked;
    this.spinner.show('addDeployment');
    this.deploymentService
      .createUpdatePartition(this.cloudValue, this.cloudName, depJsonBody, this.data.action, this.data.depName, skipCloudDep)
      .subscribe({
        next: (data) => {
          this.spinner.show('addDeployment');
          this.dialogRef.close(data?.actionMessage);
        },
        error: (err) => {
          if (err?.error?.actionMessage) {
            this.snackbar.open(err?.error?.actionMessage, 'Ok', {
              duration: 10000,
            });
          }
          this.spinner.show('addDeployment');
          this.dialogRef.close();
        },
      });

      const notifcationButton = document.querySelector('.notificationBtn');
      if (notifcationButton) {
        (notifcationButton as HTMLElement).click();
      }

      setTimeout(()=>{
        // This will refresh the notification so that the latest notfication will be shown
        const refreshButton = document.querySelector('.manualRefreshNotifications');
        if (refreshButton) {
          (refreshButton as HTMLElement).click();
        }
      }, 1000);
  }
} 

